import * as React from 'react';
import { useState, useEffect } from 'react';
import { Image as ImageType } from '../../../typings';
import 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange';

const defaultWidths = ['400', '800', '1200', '2400', '4000'];

interface ImageBasicProps {
  image: ImageType;
  widthSizes?: string[];
  isDarkened?: boolean;
  useIntrinsicHeight?: boolean;
}

const ImageBasic = ({
  image,
  widthSizes = defaultWidths,
  isDarkened = false,
  useIntrinsicHeight,
}: ImageBasicProps) => {
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [srcset, setSrcset] = useState<string>();

  useEffect(() => {
    const src = widthSizes
      .map((size: string) => `${image.file.url}?fit=thumb&fl=progressive&w=${size} ${size}w`);

    setSrcset(src.join(','));
  }, [image]);

  return (
    <img
      data-sizes="auto"
      data-srcset={srcset}
      height={useIntrinsicHeight ? image.file.details?.image.height : undefined}
      src={`${image.file.url}?fit=thumb&fl=progressive&w=${widthSizes[0] ? widthSizes[0] : defaultWidths[0]}`}
      className={`basic-image lazyload  blur-up ${isLoaded && 'image-is-loaded'} ${isDarkened ? 'has-opacity' : ''}`}
      alt={image.title ? image.title : 'image with no description'}
      onLoad={() => setIsLoaded(true)}
    />
  );
};

export default ImageBasic;
